<table class="selectableTable">
  <tr>
    <th>Account Name</th>
    <th>Contact Name</th>
    <th>Contact Email</th>
    <th>Contact Phone</th>
  </tr>
  @for (
    item of this.dataSource.data;
    track item.id;
    let even = $even;
    let odd = $odd
  ) {
    @if (item.id != undefined) {
      <tr
        id="trsummary_{{ item.id }}"
        [ngClass]="{ even: even, odd: odd }"
        class="rowSummary highlightable"
        (click)="btnManageAccount_click(item.id)"
      >
        <td style="width: 40%">{{ item.accountName }}</td>
        <td style="width: 20%">
          @if (item.contacts && item.contacts.length > 0) {
            <div>
              {{ item.contacts[0].firstName }} {{ item.contacts[0].lastName }}
            </div>
          }
        </td>
        <td style="width: 20%">
          @if (item.contacts && item.contacts.length > 0) {
            <div>{{ item.contacts[0].emailAddress }}</div>
          }
        </td>
        <td style="width: 20%">
          @if (item.contacts && item.contacts.length > 0) {
            <div>
              {{ item.contacts[0].firstName }} {{ item.contacts[0].phone }}
            </div>
          }
        </td>
      </tr>
    }
    @if (this.options.selectAction == 'expand') {
      <tr
        id="trdetails_{{ item.id }}"
        class="rowDetails noHover"
        style="display: none"
      >
        <td colspan="4"></td>
      </tr>
    }
  }
</table>
